import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../../../shared/Components/base/base.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PortalService } from '../../services/PortalService';
import { Router } from '@angular/router';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { DomSanitizer } from '@angular/platform-browser';
import { AddPortalsComponent } from '../add-portals/add-portals.component';
import { PortalsDetailsComponent } from '../portaldetails/portaldetails.component';
import { PagingService } from '../../../../shared/Services/PagingService';
import { DeleteConfirmationComponent } from '../../../delete-confirmation/delete-confirmation.component';

@Component({
  selector: 'get-portals',
  templateUrl: './get-portals.component.html',
  styleUrls: ['./get-portals.component.scss'],
})
export class GetPortalsDetailsComponent extends BaseComponent implements OnInit {
  dateTo: string;
  dateFrom: string;
  form: FormGroup;
  constructor(
    public service: PortalService,
    route: Router,
    private fb: FormBuilder,
    private diag: NbDialogService,
    private toast: NbToastrService,
    public sanitizer: DomSanitizer,
    private paging: PagingService
  ) {
    super(route, service, paging, '', diag);
  }

  ngOnInit() {
    this.intitForm();
    this.loadEntities();
  }

  getLabelData(text) {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }

  intitForm() {
    this.form = this.fb.group({
      titleAR: [''],
    });
  }

  handleSearch() {
    if (!this.form.value.titleAR && !this.dateFrom && !this.dateTo) {
      this.toast.danger('برجاء اختيار العنوان  لاتمام عملية البحث', 'رساله تحذيرية');
      return;
    }

    let serchTermArr = [];

    if (this.form.value.titleAR) {
      serchTermArr.push(`titleAR:${this.form.value.titleAR.trim()}`);
    }

    this.loadEntitiesWithFilter(serchTermArr.join(','));
  }
  clearFilter() {
    this.dateFrom = '';
    this.dateTo = '';
    this.form.controls['titleAR'].setValue('');
    this.loadEntitiesWithFilter('');
  }

  add() {
    this.dialog
      .open(AddPortalsComponent, {
        dialogClass: 'custom-dialog-height',
      })
      .onClose.subscribe((res) => {
        if (res === 'true') {
          this.toast.show('تم الاضافة بنجاح', '', { status: 'success', duration: 3000 });
          this.loadEntities();
        }
      });
  }

    delete(id) {
    this.diag.open(DeleteConfirmationComponent, {
      dialogClass: 'custom-dialog-height',
      context: {
        id: id,
        service: this.service,
        url:this.route.url
      },
    });
  }

  detail(model) {
    this.diag.open(PortalsDetailsComponent, {
      dialogClass: 'custom-dialog-height',
      context: {
        model: model,
      },
    });
  }

  update(model) {
    const copymodel = {...model}
    this.diag
      .open(AddPortalsComponent, {
        dialogClass: 'custom-dialog-height',
        context: {
          model: copymodel,
          isEdit: true,
        },
      })
      .onClose.subscribe((res) => {
        if (res === 'true') this.loadEntities();
      });
  }
}
